export default "__VITE_ASSET__COnfXt3K__"